import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

const SidebarButtonIcon = styled(FontAwesomeIcon)({
    color: 'white',
    margin: '0 0 0 8px',
    fontSize: '29px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

export type SidebarButtonProps = {
    visible: boolean;
    onClick: () => void;
}

export const SidebarButton = (props: SidebarButtonProps) => {
    return (
        <div onClick={() => props.onClick()}>
            {
                props.visible
                    ? <SidebarButtonIcon icon={faAngleDoubleLeft} />
                    : <SidebarButtonIcon icon={faAngleDoubleRight} />
            }
        </div>
    );
};
